import React, { useEffect, useState } from 'react';
import { Image } from '../shared';
import { logo, userImg } from '../../assets/img';
import { Arrow } from '../../assets/icons';
import PropTypes from 'prop-types';
import { Logout } from '../pages';
import { LOCAL_STORAGE } from '../../constants';
import { getLocalStorageItem } from '../../utils';
import { popup } from '../../utils';
import { useNodeSocket } from '../../context/NodeSocketContext';

export const Header = () => {
  const user = getLocalStorageItem(LOCAL_STORAGE.USERNAME);
  const { messages } = useNodeSocket();
  const [inProgressLotsCount, setInProgressLotsCount] = useState(0);


  useEffect(() => {
    if (!messages?.length) return;

    let currentVendorType = localStorage.getItem('vendor_type') || "";

    if (currentVendorType.startsWith('"') && currentVendorType.endsWith('"')) {
      currentVendorType = currentVendorType.slice(1, -1);
    }

    currentVendorType = currentVendorType.trim().toLowerCase();

    const latestMessage = messages[messages.length - 1];
    
    if (!latestMessage) return;

    const msgVendorType = latestMessage?.data?.type?.trim().toLowerCase();
    const result = latestMessage?.data?.result;

    if (msgVendorType === currentVendorType) {
      const hasCount = result?.in_progress_lots !== undefined;
      if (hasCount) {
        setInProgressLotsCount(result.in_progress_lots);
      }
    }

    if (msgVendorType === "final_result") {
      const finalMessageType = result?.type?.trim().toLowerCase();
      if (finalMessageType === currentVendorType) {
        popup('success', result?.result);
      }
    }
  }, [messages]);


  return (
    <header className="header bg-white">
      <div className="d-flex align-items-center">
        <div className="main-logo d-flex align-items-center justify-content-center">
          <Image src={logo} alt="logo" width="148" height="53" />
        </div>
        {inProgressLotsCount > 0 && (
          <div className="d-flex align-items-center justify-content-center ms-3">
            <span className="badge rounded-pill bg-primary badge-custom">
              {inProgressLotsCount} Lots Processing
            </span>
          </div>
        )}
        <div className="header-content w-100">
          <div className="d-flex align-items-center justify-content-end w-100">
            <button
              className="d-flex align-items-center justify-content-center border-0 p-0 bg-white icon-btn"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#ProfileSideBar"
              aria-expanded="false"
              aria-controls="collapseExample">
              {/* <Image src={userImg} width="32" height="32" className="user-img" /> */}
              {!user ? (
                <Image src={userImg} width="32" height="32" className="user-img" />
              ) : (
                <div className="display-row-text">
                  {getLocalStorageItem(LOCAL_STORAGE.USERNAME)}
                </div>
              )}
              <Arrow />
            </button>
            <Logout />
          </div>
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  userName: PropTypes.string,
};

export default Header;